import { API_URL } from '../../../constants';
import _fetch from '../../_fetch';

export default function updateBlogPost(options = {}) {
  return function withContext(context) {
    const url = `${API_URL}blog/posts/${options.id}`;
    return _fetch(
      url,
      { withAuth: true },
      {
        method: 'PATCH',
        body: JSON.stringify(options.body),
        headers: {
          'Accept': 'application/json;charset=utf-8',
          'Content-Type': 'application/json;charset=utf-8'
        }
      }
    )(context);
  };
}
